import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a5bf0d5e&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style1 from "./List.vue?vue&type=style&index=1&id=a5bf0d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bf0d5e",
  null
  
)

export default component.exports